import { boot } from '@dazn/bootstrap-lib';

type customFeatureFlagsType = {
    [featureName: string]: {
        staging: string[];
        production: string[];
        development: string[];
        testing: string[];
        edge: string[];
    };
};

const customFeatureFlags: customFeatureFlagsType = {
    cff_anonymous_playback: {
        staging: ['*'],
        production: ['*'],
        development: ['*'],
        testing: ['*'],
        edge: ['*'],
    },
};

const getCustomFeatureFlags = (
    name: string,
    environment: boot.config.Environment,
    countryGroup:
        | 'MENA'
        | 'MOON'
        | boot.config.NativeCountryOrMoon
        | boot.config.AnyCountry,
) => {
    if (environment && name && countryGroup) {
        return (
            (customFeatureFlags[name]?.[environment]).indexOf(countryGroup) >
                -1 ||
            (customFeatureFlags[name]?.[environment]).indexOf('*') > -1
        );
    } else {
        return false;
    }
};

export { getCustomFeatureFlags };
